// Reads config from `window.config` at runtime (see `web/.docker/env.sh`),
// falling back to Vite's `import.meta.env.VITE_*`.
// Use `env()` / `settings` instead of reading those directly.

// Spread the whole `import.meta.env` so Vite inlines it; dynamic access like
// `import.meta.env[key]` is not replaced at build time.
const fromVite = Object.fromEntries(
  Object.entries(import.meta.env).map(([key, value]) => [key.replace(/^VITE_/, ""), value]),
);

const config: Record<string, unknown> = { ...fromVite, ...window.config };

export const env = (key: string, fallback = ""): string => {
  const value = config[key];
  return value === undefined || value === null ? fallback : String(value);
};

export const settings = {
  apiBaseUrl: env("API_BASE_URL", "http://localhost:8000/api/v1"),
  azureAppClientId: env("AZURE_APP_CLIENT_ID"),
  azureAppTenantId: env("AZURE_APP_TENANT_ID"),
  pholisPollIntervalMs: Number(env("PHOLIS_POLL_INTERVAL_MS")) || 4000,
  pholisDashboardBaseUrl: env("PHOLIS_DASHBOARD_BASE_URL"),
} as const;

// delete window.config after processing so nothing uses it by mistake
delete window.config;
